import { render } from "./ZapiCategoryTabs.vue?vue&type=template&id=1328e6ec"
import script from "./ZapiCategoryTabs.vue?vue&type=script&lang=js"
export * from "./ZapiCategoryTabs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__